export default "__VITE_ASSET__DjKKzrl1__"